import axios from "../config/axios";
import config from "../config/index";
const outbound = {
   getTimezones: () =>
       axios
           .get(`${config.apiBaseURL2}timezones`)
           .then((resp) => resp.data)
           .catch((err) => err),


   saveCampaign: (params) =>
       axios
           .post(`${config.apiBaseURL2}campaigns`, params)
           .then((resp) => resp.data)
           .catch((err) => {
               return {
                   status: false,
                   message: err.response?.data?.message || 'Network error occurred',
                   error: err.message
               };
           }),

   storeSmsCampaign: (params) =>
       axios
           .post(`${config.apiBaseURL2}sms-campaigns`, params)
           .then((resp) => resp.data)
           .catch((err) => {
               return {
                   status: false,
                   message: err.response?.data?.message || 'Network error occurred',
                   error: err.message,
                   errors: err.response?.data?.errors || {}
               };
           }),
   getCampaign: (id, timezone) =>
       axios
           .get(`${config.apiBaseURL2}campaigns/${id}`, { params: { timezone } })
           .then((resp) => resp.data)
           .catch((err) => {
               return {
                   status: false,
                   message: err.response?.data?.message || 'Network error occurred',
                   error: err.message
               };
           }),
   updateCampaign: (id, params) =>
       axios
           .put(`${config.apiBaseURL2}campaigns/${id}`, params)
           .then((resp) => resp.data)
           .catch((err) => {
               return {
                   status: false,
                   message: err.response?.data?.message || 'Network error occurred',
                   error: err.message
               };
           }),
   updateCampaignWebhookQueueDelay: (id, webhook_queue_delay_days) =>
       axios
           .patch(`${config.apiBaseURL2}campaigns/${id}/webhook-queue-delay`, {
               webhook_queue_delay_days,
           })
           .then((resp) => resp.data)
           .catch((err) => ({
               status: false,
               message: err.response?.data?.message || 'Network error occurred',
               error: err.message,
           })),
   /**
    * Per-campaign duplicate-phone rule (reject if same number added within N days).
    * Body: { duplicate_data_rule_enabled: boolean, duplicate_data_rule_days: number|null }
    */
   updateCampaignDuplicateDataRule: (id, duplicate_data_rule_enabled, duplicate_data_rule_days) =>
       axios
           .patch(`${config.apiBaseURL2}campaigns/${id}/duplicate-data-rule`, {
               duplicate_data_rule_enabled: !!duplicate_data_rule_enabled,
               duplicate_data_rule_days:
                   duplicate_data_rule_enabled && duplicate_data_rule_days != null
                       ? duplicate_data_rule_days
                       : null,
           })
           .then((resp) => resp.data)
           .catch((err) => ({
               status: false,
               message: err.response?.data?.message || 'Network error occurred',
               error: err.message,
           })),
   updateCampaignStatus: (id, status) =>
       axios
           .post(`${config.apiBaseURL2}campaigns/${id}/status`, { status })
           .then((resp) => resp.data)
           .catch((err) => ({ status: false, message: err.response?.data?.message || 'Network error occurred', error: err.message })),
   deleteCampaign: (id, params) =>
       axios
           .delete(`${config.apiBaseURL2}campaigns/${id}`, { params })
           .then((resp) => resp.data)
           .catch((err) => {
               return {
                   status: false,
                   message: err.response?.data?.message || 'Network error occurred',
                   error: err.message
               };
           }),
   CampaignsList: (params) =>
       axios
           .get(`${config.apiBaseURL2}campaigns`, { params })
           .then((resp) => resp.data)
           .catch((err) => {
               return {
                   status: false,
                   message: err.response?.data?.message || 'Network error occurred',
                   error: err.message
               };
           }),


   getActiveOutboundWorkspaces: (params) =>
       axios
           .get(`${config.apiBaseURL2}outbound/active-outbound-workspaces`, { params })
           .then((resp) => resp.data)
           .catch((err) => err),

   getAvailableOutboundNumbers: () =>
       axios
           .get(`${config.apiBaseURL2}campaigns/available-outbound-numbers`)
           .then((resp) => resp.data)
           .catch((err) => {
               return {
                   status: false,
                   message: err.response?.data?.message || 'Network error occurred',
                   error: err.message,
                   data: [],
               };
           }),

   getAvailableCallerIds: () =>
       axios
           .get(`${config.apiBaseURL2}campaigns/available-caller-ids`)
           .then((resp) => resp.data)
           .catch((err) => {
               return {
                   status: false,
                   message: err.response?.data?.message || 'Network error occurred',
                   error: err.message,
                   data: [],
               };
           }),

   getOutboundSmsPhoneNumbers: (params) =>
       axios
           .post(`${config.apiBaseURL2}outbound-sms/phone-numbers`, params)
           .then((resp) => resp.data)
           .catch((err) => {
               return {
                   status: false,
                   message: err.response?.data?.message || 'Network error occurred',
                   error: err.message,
                   data: [],
               };
           }),

   getAccountDefaultTimezone: (params) =>
       axios
           .get(`${config.apiBaseURL2}account/default-timezone`, { params })
           .then((resp) => resp.data)
           .catch((err) => {
               return {
                   status: false,
                   message: err.response?.data?.message || 'Network error occurred',
                   error: err.message
               };
           }),


   saveVoicemailMessage: (params) =>
       axios
           .post(`${config.apiBaseURL2}outbound/voice-mail-message`, params)
           .then((resp) => resp.data)
           .catch((err) => err),


   getVoicemailMessage: (params) =>
       axios
           .get(`${config.apiBaseURL2}outbound/voice-mail-message`, { params })
           .then((resp) => resp.data)
           .catch((err) => err),




   saveStirShaken: (params) =>
       axios
           .post(`${config.apiBaseURL2}trust-hub/profile/create-stir-shaken-trust-product`, params)
           .then((resp) => resp.data)
           .catch((err) => {
               return {
                   status: false,
                   message: err.response?.data?.message || 'Network error occurred',
                   error: err.message
               };
           }),


   saveCNAM: (params) =>
       axios
           .post(`${config.apiBaseURL2}trust-hub/profile/create-cnam-trust-product`, params)
           .then((resp) => resp.data)
           .catch((err) => {
               return {
                   status: false,
                   message: err.response?.data?.message || 'Network error occurred',
                   error: err.message
               };
           }),


   getCNAMDetails: (id) =>
       axios
           .get(`${config.apiBaseURL2}trust-hub/profile/get-cnam-trust-product/${id}`)
           .then((resp) => resp.data)
           .catch((err) => {
               return {
                   status: false,
                   message: err.response?.data?.message || 'Network error occurred',
                   error: err.message
               };
           }),


   updateCNAM: (params) =>
       axios
           .post(`${config.apiBaseURL2}trust-hub/profile/update-cnam-trust-product`, params)
           .then((resp) => resp.data)
           .catch((err) => {
               return {
                   status: false,
                   message: err.response?.data?.message || 'Network error occurred',
                   error: err.message
               };
           }),


   getTrustProductStatus: (id) =>
       axios
           .get(`${config.apiBaseURL2}trust-hub/profile/get-trust-product-status/${id}`, {})
           .then((resp) => resp.data)
           .catch((err) => err),


   storeTriggeredCampaignCustomers: (encryptedCampaignId, customers, options = {}) => {
       const { skipWebhookQueueDelay = false } = options;
       const headers =
           skipWebhookQueueDelay ? { 'X-ZyraTalk-Internal-Triggered-Ingest': '1' } : {};
       return axios
           .post(`${config.apiBaseURL2}${encryptedCampaignId}`, { customers }, { headers })
           .then((resp) => resp.data)
           .catch((err) => {
               // Validation failures answer 422; keep field-level errors so forms can show them per row.
               return {
                   status: false,
                   message: err.response?.data?.message || 'Network error occurred',
                   errors: err.response?.data?.errors,
                   error: err.message
               };
           });
   },


   deleteCampaignCustomer: (customerId) =>
       axios
           .delete(`${config.apiBaseURL2}campaigns/delete-customer/${customerId}`)
           .then((resp) => resp.data)
           .catch((err) => {
               return {
                   status: false,
                   message: err.response?.data?.message || 'Network error occurred',
                   error: err.message
               };
           }),

   /**
    * Delete multiple campaign customers in one request (scoped by campaign on the server).
    * Body: { customer_ids: number[] } ? caller is responsible for valid, deduped IDs.
    */
   bulkDeleteCampaignCustomers: (campaignId, customerIds) =>
       axios
           .post(`${config.apiBaseURL2}campaigns/${campaignId}/customers/bulk-delete`, {
               customer_ids: customerIds,
           })
           .then((resp) => resp.data)
           .catch((err) => {
               return {
                   status: false,
                   message: err.response?.data?.message || 'Network error occurred',
                   error: err.message,
               };
           }),

   updateCampaignCustomerOptOut: (customerId, callerOptedOut) =>
       axios
           .put(`${config.apiBaseURL2}campaigns/customers/${customerId}/opt-out`, {
               caller_opted_out: !!callerOptedOut
           })
           .then((resp) => resp.data)
           .catch((err) => {
               return {
                   status: false,
                   message: err.response?.data?.message || 'Network error occurred',
                   error: err.message
               };
           }),

   /**
    * Get Voice Integrity trust product details
    *
    * @param {number} userId - User ID to fetch Voice Integrity data for
    * @returns {Promise<Object>} API response with Voice Integrity data
    */
   getVoiceIntegrityDetails: (userId) =>
       axios
           .get(`${config.apiBaseURL2}trust-hub/profile/get-voice-integrity-trust-product/${userId}`)
           .then((resp) => resp.data)
           .catch((err) => {
               return {
                   status: false,
                   message: err.response?.data?.message || 'Network error occurred',
                   error: err.message
               };
           }),


   /**
     * Create a new Voice Integrity trust product
     *
     * @param {Object} params - Voice Integrity form payload
     * @returns {Promise<Object>} API response
     */
   createVoiceIntegrity: (params) =>
       axios
           .post(`${config.apiBaseURL2}trust-hub/profile/create-voice-integrity-trust-product`, params)
           .then((resp) => resp.data)
           .catch((err) => {
               return {
                   status: false,
                   message: err.response?.data?.message || 'Network error occurred',
                   error: err.message
               };
           }),


   /**
    * Update an existing Voice Integrity trust product
    *
    * @param {Object} params - Updated Voice Integrity payload
    * @returns {Promise<Object>} API response
    */
   updateVoiceIntegrity: (params) =>
       axios
           .post(`${config.apiBaseURL2}trust-hub/profile/update-voice-integrity-trust-product`, params)
           .then((resp) => resp.data)
           .catch((err) => {
               return {
                   status: false,
                   message: err.response?.data?.message || 'Network error occurred',
                   error: err.message
               };
           }),

   /**
    * Get A2P Brand and Campaign status for a user
    *
    * @param {number} userId - User ID
    * @returns {Promise<Object>} API response with brand_status and campaign_status
    */
   getA2PStatus: (userId) =>
       axios
           .get(`${config.apiBaseURL2}a2p/status/${userId}`)
           .then((resp) => resp.data)
           .catch((err) => {
               return {
                   status: false,
                   message: err.response?.data?.message || 'Network error occurred',
                   error: err.message
               };
           }),

   /**
    * Get full SMS / A2P compliance status for outbound SMS campaigns
    *
    * @param {number} userId - User ID
    * @returns {Promise<Object>} profile, brand, campaign, and phone assignment status
    */
   getSmsComplianceStatus: (userId) =>
       axios
           .get(`${config.apiBaseURL2}a2p/compliance/sms-status/${userId}`)
           .then((resp) => resp.data)
           .catch((err) => {
               return {
                   status: false,
                   message: err.response?.data?.message || 'Network error occurred',
                   error: err.message
               };
           }),

   /**
    * Get A2P Brand details for a user (for editing/resubmission)
    *
    * @param {number} userId - User ID
    * @returns {Promise<Object>} API response with brand details
    */
   getA2PBrandDetails: (userId) =>
       axios
           .get(`${config.apiBaseURL2}a2p/brand/${userId}/details`)
           .then((resp) => resp.data)
           .catch((err) => {
               return {
                   status: false,
                   message: err.response?.data?.message || 'Network error occurred',
                   error: err.message
               };
           }),

   /**
    * Get A2P Campaign details for a user (for editing/resubmission)
    *
    * @param {number} userId - User ID
    * @returns {Promise<Object>} API response with campaign details
    */
   getA2PCampaignDetails: (userId) =>
       axios
           .get(`${config.apiBaseURL2}a2p/campaign/${userId}/details`)
           .then((resp) => resp.data)
           .catch((err) => {
               return {
                   status: false,
                   message: err.response?.data?.message || 'Network error occurred',
                   error: err.message
               };
           }),

   /**
    * Create A2P Brand registration
    * Handles both Scenario A (user has TrustHub) and Scenario B (no TrustHub)
    *
    * @param {Object} params - Brand registration payload
    * @returns {Promise<Object>} API response
    */
   createA2PBrand: (params) =>
       axios
           .post(`${config.apiBaseURL2}a2p/brand/create`, params)
           .then((resp) => resp.data)
           .catch((err) => {
               return {
                   status: false,
                   message: err.response?.data?.message || 'Failed to create A2P Brand',
                   errors: err.response?.data?.errors || {},
                   error: err.message
               };
           }),

   /**
    * Update A2P Brand registration (for resubmission after rejection or editing draft)
    *
    * @param {Object} params - Brand update payload
    * @returns {Promise<Object>} API response
    */
   updateA2PBrand: (params) =>
       axios
           .post(`${config.apiBaseURL2}a2p/brand/update`, params)
           .then((resp) => resp.data)
           .catch((err) => {
               return {
                   status: false,
                   message: err.response?.data?.message || 'Failed to update A2P Brand',
                   errors: err.response?.data?.errors || {},
                   error: err.message
               };
           }),

   /**
    * Create A2P Campaign registration
    *
    * @param {Object} params - Campaign registration payload
    * @returns {Promise<Object>} API response
    */
   createA2PCampaign: (params) =>
       axios
           .post(`${config.apiBaseURL2}a2p/campaign/create`, params)
           .then((resp) => resp.data)
           .catch((err) => {
               return {
                   status: false,
                   message: err.response?.data?.message || 'Failed to create A2P Campaign',
                   errors: err.response?.data?.errors || {},
                   error: err.message
               };
           }),

   /**
    * Update A2P Campaign registration (for resubmission after rejection or editing draft)
    *
    * @param {Object} params - Campaign update payload
    * @returns {Promise<Object>} API response
    */
   updateA2PCampaign: (params) =>
       axios
           .post(`${config.apiBaseURL2}a2p/campaign/update`, params)
           .then((resp) => resp.data)
           .catch((err) => {
               return {
                   status: false,
                   message: err.response?.data?.message || 'Failed to update A2P Campaign',
                   errors: err.response?.data?.errors || {},
                   error: err.message
               };
           }),

   /**
    * Assign phone number to A2P Campaign
    *
    * @param {Object} params - { user_id, a2p_campaign_id, phone_number_sid }
    * @returns {Promise<Object>} API response
    */
   assignPhoneToA2PCampaign: (params) =>
       axios
           .post(`${config.apiBaseURL2}a2p/campaign/assign-phone`, params)
           .then((resp) => resp.data)
           .catch((err) => {
               return {
                   success: false,
                   message: err.response?.data?.message || 'Failed to assign phone number',
                   error: err.message
               };
           }),

   /**
    * Remove phone number from A2P Campaign
    *
    * @param {number} assignmentId - Assignment ID to remove
    * @returns {Promise<Object>} API response
    */
   removePhoneFromA2PCampaign: (assignmentId) =>
       axios
           .delete(`${config.apiBaseURL2}a2p/campaign/remove-phone/${assignmentId}`)
           .then((resp) => resp.data)
           .catch((err) => {
               return {
                   success: false,
                   message: err.response?.data?.message || 'Failed to remove phone number',
                   error: err.message
               };
           }),

   /**
    * Get phone numbers assigned to A2P Campaign
    *
    * @param {number} campaignId - Campaign ID
    * @returns {Promise<Object>} API response with assigned phones
    */
   getA2PCampaignPhones: (campaignId) =>
       axios
           .get(`${config.apiBaseURL2}a2p/campaign/${campaignId}/phones`)
           .then((resp) => resp.data)
           .catch((err) => {
               return {
                   success: false,
                   message: err.response?.data?.message || 'Failed to get assigned phone numbers',
                   error: err.message
               };
           }),

   /**
    * Get user's phone numbers from zyra_twilio_numbers
    *
    * @param {number} userId - User ID
    * @returns {Promise<Object>} API response with phones and assignment status
    */
   getUserPhoneNumbers: (userId) =>
       axios
           .get(`${config.apiBaseURL2}a2p/phones/${userId}`)
           .then((resp) => resp.data)
           .catch((err) => {
               return {
                   success: false,
                   message: err.response?.data?.message || 'Failed to get phone numbers',
                   error: err.message
               };
           }),

   /**
    * Auto-assign all user's phone numbers to approved campaign
    *
    * @param {Object} params - { user_id }
    * @returns {Promise<Object>} API response
    */
   autoAssignPhonesToCampaign: (params) =>
       axios
           .post(`${config.apiBaseURL2}a2p/phones/auto-assign`, params)
           .then((resp) => resp.data)
           .catch((err) => {
               return {
                   success: false,
                   message: err.response?.data?.message || 'Failed to auto-assign phone numbers',
                   error: err.message
               };
           }),

    duplicateCampaign: (params) =>
       axios
           .post(`${config.apiBaseURL2}campaigns/duplicate`, params)
           .then((resp) => resp.data)
           .catch((err) => {
               return {
                   status: false,
                   message: err.response?.data?.message || 'Network error occurred',
                   error: err.message
               };
           }),

   /**
    * Get SMS campaigns list for a user with pagination and sorting
    *
    * @param {Object} params - Query parameters
    * @param {number} params.user_id - User ID
    * @param {number} [params.page] - Page number (default: 1)
    * @param {number} [params.limit] - Items per page (default: 10)
    * @param {string} [params.sort_column] - Column to sort by (created_at, start_date, status)
    * @param {string} [params.sort_direction] - Sort direction (asc or desc)
    * @param {string} [params.search] - Search term for campaign name
    * @returns {Promise<Object>} API response with campaigns list
    */
   getSmsCampaignsList: (params) =>
       axios
           .get(`${config.apiBaseURL2}sms-campaigns`, { params })
           .then((resp) => resp.data)
           .catch((err) => {
               return {
                   status: false,
                   message: err.response?.data?.message || 'Network error occurred',
                   error: err.message,
                   data: { campaigns: [], pagination: { total: 0, current_page: 1, last_page: 0 } }
               };
           }),

   /**
    * Get a single SMS campaign by ID with full details including customers
    *
    * @param {number} id - Campaign ID
    * @param {string} [timezone] - Client timezone
    * @returns {Promise<Object>} API response with campaign details
    */
   getSmsCampaign: (id, timezone) =>
       axios
           .get(`${config.apiBaseURL2}sms-campaigns/${id}`, { params: { timezone } })
           .then((resp) => resp.data)
           .catch((err) => {
               return {
                   status: false,
                   message: err.response?.data?.message || 'Network error occurred',
                   error: err.message
               };
           }),

   updateSmsCampaign: (params) =>
       axios
           .post(`${config.apiBaseURL2}sms-campaigns/update`, params)
           .then((resp) => resp.data)
           .catch((err) => {
               return {
                   status: false,
                   message: err.response?.data?.message || 'Network error occurred',
                   errors: err.response?.data?.errors,
                   error: err.message
               };
           }),

   updateSmsCampaignStatus: (id, status) =>
       axios
           .post(`${config.apiBaseURL2}sms-campaigns/${id}/status`, { status })
           .then((resp) => resp.data)
           .catch((err) => {
               return {
                   status: false,
                   message: err.response?.data?.message || 'Network error occurred',
                   error: err.message
               };
           }),

   saveSmsCampaignVoiceSources: (id, params) =>
       axios
           .post(`${config.apiBaseURL2}sms-campaigns/${id}/voice-sources`, params)
           .then((resp) => resp.data)
           .catch((err) => {
               return {
                   status: false,
                   message: err.response?.data?.message || 'Network error occurred',
                   error: err.message
               };
           }),

   /**
    * Get SMS campaign interaction chat log for the Interactions tab
    */
   getSmsCampaignChatLog: (params) =>
       axios
           .get(`${config.apiBaseURL2}sms-campaigns/chat-log`, { params })
           .then((resp) => resp.data)
           .catch((err) => {
               return {
                   status: false,
                   message: err.response?.data?.message || 'Network error occurred',
                   error: err.message,
                   data: { list: [], totalrecord: 0, workspaceList: [] }
               };
           }),

   /**
    * Store customers for an outbound SMS triggered campaign.
    * Uses the route: /outbound-sms/{encryptedCampaignId}
    *
    * @param {string} encryptedCampaignId - Base64 encoded user_id/campaign_id
    * @param {Array} customers - Array of customer objects { name, phone_number, ... }
    * @param {Object} [options] - Optional settings
    * @param {boolean} [options.skipWebhookQueueDelay] - Whether to skip webhook queue delay
    * @returns {Promise<Object>} API response
    */
   storeSmsCampaignCustomers: (encryptedCampaignId, customers, options = {}) => {
       const { skipWebhookQueueDelay = false } = options;
       const headers = {
           'X-ZyraTalk-Outbound-Sms-Webhook-type': 'web',
           ...(skipWebhookQueueDelay ? { 'X-ZyraTalk-Internal-Triggered-Ingest': '1' } : {}),
       };
       return axios
           .post(`${config.apiBaseURL2}outbound-sms/${encryptedCampaignId}`, { customers }, { headers })
           .then((resp) => resp.data)
           .catch((err) => {
               return {
                   status: false,
                   message: err.response?.data?.message || 'Network error occurred',
                   error: err.message
               };
           });
   },

   /**
    * Delete multiple SMS campaign customers in one request
    *
    * @param {number} campaignId - SMS Campaign ID
    * @param {Array<number>} customerIds - Array of customer IDs to delete
    * @returns {Promise<Object>} API response
    */
   bulkDeleteSmsCampaignCustomers: (campaignId, customerIds) =>
       axios
           .post(`${config.apiBaseURL2}sms-campaigns/${campaignId}/customers/bulk-delete`, {
               customer_ids: customerIds,
           })
           .then((resp) => resp.data)
           .catch((err) => {
               return {
                   status: false,
                   message: err.response?.data?.message || 'Network error occurred',
                   error: err.message
               };
           }),
}
export default outbound;
